module.exports = __webpack_public_path__ + "static/media/twoBoxesOnHoriztonalPlane1.82363e71.svg";